import heartroutineLandingPage from '../img/projects/heartroutine/heartroutine-landing-page.png';
import heartroutineAppScreenshot from '../img/projects/heartroutine/heartroutine-app-screenshot.PNG';
import heartroutineInbox from '../img/projects/heartroutine/heartroutine-inbox.png';
import heartroutineReport from '../img/projects/heartroutine/heartroutine-report-zoomed-screenshot.PNG';
import heartroutineLandingPageThumb from '../img/projects/thumbs/heartroutine-landing-page.jpg';
import heartroutineAppScreenshotThumb from '../img/projects/thumbs/heartroutine-app-screenshot.jpg';
import heartroutineInboxThumb from '../img/projects/thumbs/heartroutine-inbox.jpg';
import heartroutineReportThumb from '../img/projects/thumbs/heartroutine-report.jpg';

import johnnyMinnCapsule from '../img/projects/putoneinforjohnnyminn/JohnnyMinn_SteamCapsule_1232x706_005_WithLogo.png';
import johnnyMinnTrailerMP4 from '../img/projects/putoneinforjohnnyminn/johnny-minn-trailer.mp4';
import johnnyMinnCapsuleThumb from '../img/projects/thumbs/johnny-minn-capsule.jpg';

import polyfillThumbnail from '../img/projects/polyfill/polyfill-thumbnail.jpg';
import polyfillTrailerMP4 from '../img/projects/polyfill/polyfill-trailer.mp4';

import bookreportHome from '../img/projects/bookreport/home.png';
import bookreportHr from '../img/projects/bookreport/hr.png';
import bookreportSpendAnalysis from '../img/projects/bookreport/spend-analysis.png';
import bookreportPurchasingMP4 from '../img/projects/bookreport/purchasing.mp4';
import bookreportPurchasingWebM from '../img/projects/bookreport/purchasing.webm';
import bookreportAccountingMP4 from '../img/projects/bookreport/accounting.mp4';
import bookreportAccountingWebM from '../img/projects/bookreport/accounting.webm';
import bookreportBankRecMP4 from '../img/projects/bookreport/bankrec.mp4';
import bookreportBankRecWebM from '../img/projects/bookreport/bankrec.webm';
import bookreportAccountCodeSearchMP4 from '../img/projects/bookreport/account-code-search.mp4';
import bookreportAccountCodeSearchWebM from '../img/projects/bookreport/account-code-search.webm';
import bookreportBudgetsMP4 from '../img/projects/bookreport/budgets.mp4';
import bookreportBudgetsWebM from '../img/projects/bookreport/budgets.webm';
import bookreportBoardReportsMP4 from '../img/projects/bookreport/board-reports.mp4';
import bookreportBoardReportsWebM from '../img/projects/bookreport/board-reports.webm';
import bookreportOrgAdminMP4 from '../img/projects/bookreport/org-admin.mp4';
import bookreportOrgAdminWebM from '../img/projects/bookreport/org-admin.webm';
import bookreportHomeThumb from '../img/projects/thumbs/bookreport-home.jpg';

import dolphinHome from '../img/projects/dolphin/dolphin-home.png';
import dolphinAnalytics from '../img/projects/dolphin/dolphin-analytics.png';
import dolphinHailMP4 from '../img/projects/dolphin/hail.mp4';
import dolphinHailWebM from '../img/projects/dolphin/hail.webm';
import dolphinWindMP4 from '../img/projects/dolphin/wind.mp4';
import dolphinWindWebM from '../img/projects/dolphin/wind.webm';
import dolphinPointsnappingMP4 from '../img/projects/dolphin/pointsnapping.mp4';
import dolphinPointsnappingWebM from '../img/projects/dolphin/pointsnapping.webm';
import dolphinUploadMP4 from '../img/projects/dolphin/upload.mp4';
import dolphinUploadWebM from '../img/projects/dolphin/upload.webm';
import dolphinCheckoutMP4 from '../img/projects/dolphin/checkout.mp4';
import dolphinCheckoutWebM from '../img/projects/dolphin/checkout.webm';
import dolphinTilesMP4 from '../img/projects/dolphin/tiles.mp4';
import dolphinTilesWebM from '../img/projects/dolphin/tiles.webm';
import dolphinHomeThumb from '../img/projects/thumbs/dolphin-home.jpg';

import kpFullScreen from '../img/projects/kalimpong/kp-full-screen.png';
import kpSteamTrailerMP4 from '../img/projects/kalimpong/kp-steam-trailer.mp4';
import kpSteamTrailerWebM from '../img/projects/kalimpong/kp-steam-trailer.webm';
import kpFullScreenThumb from '../img/projects/thumbs/kp-full-screen.jpg';

import culturebookHome from '../img/projects/culturebook/home.png';
import culturebookMP4 from '../img/projects/culturebook/culturebook.mp4';
import culturebookWebM from '../img/projects/culturebook/culturebook.webm';
import culturebookHomeThumb from '../img/projects/thumbs/culturebook-home.jpg';

import tugboatMP4 from '../img/projects/tugboat/tugboat.mp4';
import tugboatWebM from '../img/projects/tugboat/tugboat.webm';
import tugboatThumb from '../img/projects/thumbs/tugboat.jpg';

import goodLogo from '../img/projects/good/good-logo.jpg';
import msoLogo from '../img/projects/mso/logo.png';
import dbvmapperHome from '../img/projects/dbvmapper/dbvmapper.png';
import goodLogoThumb from '../img/projects/thumbs/good-logo.jpg';
import msoLogoThumb from '../img/projects/thumbs/mso-logo.jpg';
import dbvmapperHomeThumb from '../img/projects/thumbs/dbvmapper.jpg';

import spacebookIcon from '../img/projects/spacebook/spacebook-icon.png';
import spacebookDetail from '../img/projects/spacebook/spacebook-detail.png';
import spacebookFullscreen from '../img/projects/spacebook/spacebook-fullscreen.png';
import spacebookGrid from '../img/projects/spacebook/spacebook-grid.png';
import spacebookIPhone from '../img/projects/spacebook/spacebook-iphone.png';
import spacebookSearch from '../img/projects/spacebook/spacebook-search.png';
import spacebookShuttle from '../img/projects/spacebook/spacebook-shuttle.png';
import spacebookDetailThumb from '../img/projects/thumbs/spacebook-detail.jpg';
import spacebookFullscreenThumb from '../img/projects/thumbs/spacebook-fullscreen.jpg';
import spacebookGridThumb from '../img/projects/thumbs/spacebook-grid.jpg';
import spacebookIPhoneThumb from '../img/projects/thumbs/spacebook-iphone.jpg';
import spacebookSearchThumb from '../img/projects/thumbs/spacebook-search.jpg';
import spacebookShuttleThumb from '../img/projects/thumbs/spacebook-shuttle.jpg';

export const heartroutine = {
  name: 'HeartRoutine',
  role: 'Creator',
  url: 'https://heartroutine.com',
  urlText: 'heartroutine.com',
  description: 'A heart health tool I built to help me lower my LDL and ApoB. I didn\'t want to have to remember to open another app to track my diet and exercise, so I made something that emails and texts me to ask me about my habits.',
  thumbnail: heartroutineLandingPageThumb,
  video: null,
  lightBg: true,
  thumbnailPosition: 'left center',
  media: [
    { type: 'image', src: heartroutineLandingPage, thumb: heartroutineLandingPageThumb },
    { type: 'image', src: heartroutineAppScreenshot, thumb: heartroutineAppScreenshotThumb },
    { type: 'image', src: heartroutineInbox, thumb: heartroutineInboxThumb },
    { type: 'image', src: heartroutineReport, thumb: heartroutineReportThumb },
  ],
}

export const johnnyMinn = {
  name: 'Put One In for Johnny Minn',
  role: 'Creator & Programmer',
  url: 'https://store.steampowered.com/app/3802120/Put_One_In_for_Johnny_Minn/',
  urlText: 'Play it on Steam',
  description: 'I made this physics soccer game because I wanted to score nice goals. After King of Kalimpong, I also wanted to build and ship a small game. The title is something I said when I was 9 years old that made my older brothers and my Dad laugh.',
  thumbnail: johnnyMinnCapsuleThumb,
  video: { mp4: johnnyMinnTrailerMP4 },
  media: [
    { type: 'image', src: johnnyMinnCapsule },
    { type: 'video', mp4: johnnyMinnTrailerMP4 },
  ],
}

export const polyfill = {
  name: 'Polyfill',
  role: 'Creator',
  url: null,
  description: `
    A platform my friend Ryan and I built to make hiring developers and finding part-time work
    for ourselves easier. Developers really liked it, but we could never get the hiring side of the marketplace to take off.`,
  thumbnail: polyfillThumbnail,
  video: { mp4: polyfillTrailerMP4 + '#t=13' },
  lightBg: true,
  media: [
    { type: 'image', src: polyfillThumbnail },
    { type: 'video', mp4: polyfillTrailerMP4 + '#t=13' },
  ],
}

export const kalimpong = {
  name: 'King of Kalimpong',
  role: 'Creator & Programmer',
  url: 'https://store.steampowered.com/app/1989110/King_of_Kalimpong/',
  urlText: 'Wishlist it on Steam',
  description: `A fast-paced team-based online multiplayer vehicle shooter built in Unreal Engine 4 C++.
    The biggest challenge was delivering good-feeling gameplay for non-deterministic physics simulations
    moving at the (relatively slow) speed of the network. I was able to make networked games feel as smooth as
    playing offline at up to about ~300ms latency, and I built a game coordinator in go to handle the server
    orchestration and matchmaking.`,
  thumbnail: kpFullScreenThumb,
  video: { mp4: kpSteamTrailerMP4, webm: kpSteamTrailerWebM },
  media: [
    { type: 'image', src: kpFullScreen },
    { type: 'video', mp4: kpSteamTrailerMP4, webm: kpSteamTrailerWebM },
  ],
}

export const bookreport = {
  name: 'Bookreport',
  role: 'Co-founder & CTO',
  url: 'http://bookreport.io',
  description: `A financial ERP for K-12 schools integrating purchasing, approvals, accounting, HR, reporting, and budgeting.
                I built the platform from the ground up in go and javascript.`,
  thumbnail: bookreportHomeThumb,
  video: { mp4: bookreportPurchasingMP4, webm: bookreportPurchasingWebM },
  thumbnailPosition: 'left center',
  media: [
    { type: 'image', src: bookreportHome },
    { type: 'video', mp4: bookreportPurchasingMP4, webm: bookreportPurchasingWebM },
    { type: 'video', mp4: bookreportAccountingMP4, webm: bookreportAccountingWebM },
    { type: 'video', mp4: bookreportBankRecMP4, webm: bookreportBankRecWebM },
    { type: 'video', mp4: bookreportAccountCodeSearchMP4, webm: bookreportAccountCodeSearchWebM },
    { type: 'video', mp4: bookreportBudgetsMP4, webm: bookreportBudgetsWebM },
    { type: 'video', mp4: bookreportBoardReportsMP4, webm: bookreportBoardReportsWebM },
    { type: 'video', mp4: bookreportOrgAdminMP4, webm: bookreportOrgAdminWebM },
    { type: 'image', src: bookreportSpendAnalysis },
    { type: 'image', src: bookreportHr },
  ],
}

export const dolphin = {
  name: 'Dolphin AI',
  role: 'Co-founder & CTO',
  url: 'http://dolphinai.com',
  urlText: 'dolphinai.com',
  description: `An aerial computer vision platform for the insurance industry.
                I led engineering and data science, built the data pipeline,
                and trained CV models for detecting storm damage to roofs.`,
  thumbnail: dolphinHomeThumb,
  video: { mp4: dolphinHailMP4, webm: dolphinHailWebM },
  media: [
    { type: 'image', src: dolphinHome },
    { type: 'image', src: dolphinAnalytics },
    { type: 'video', mp4: dolphinHailMP4, webm: dolphinHailWebM },
    { type: 'video', mp4: dolphinWindMP4, webm: dolphinWindWebM },
    { type: 'video', mp4: dolphinPointsnappingMP4, webm: dolphinPointsnappingWebM },
    { type: 'video', mp4: dolphinUploadMP4, webm: dolphinUploadWebM },
    { type: 'video', mp4: dolphinCheckoutMP4, webm: dolphinCheckoutWebM },
    { type: 'video', mp4: dolphinTilesMP4, webm: dolphinTilesWebM },
  ],
}

export const culturebook = {
  name: 'The Black Tux | Culture Book',
  role: 'Developer',
  url: 'https://culture.theblacktux.com',
  description: 'A mobile web app I built for The Black Tux as a guide to working together.',
  thumbnail: culturebookHomeThumb,
  video: { mp4: culturebookMP4, webm: culturebookWebM },
  lightBg: true,
  media: [
    { type: 'image', src: culturebookHome },
    { type: 'video', mp4: culturebookMP4, webm: culturebookWebM },
  ],
}

export const tugboat = {
  name: 'Tugboat',
  role: 'Author',
  url: null,
  description: `A Go CLI I wrote to simplify the management of Bookreport's customers' Kubernetes clusters.`,
  thumbnail: tugboatThumb,
  video: { mp4: tugboatMP4, webm: tugboatWebM },
  media: [
    { type: 'video', mp4: tugboatMP4, webm: tugboatWebM },
  ],
}

export const good = {
  name: 'GOOD.is',
  role: 'Senior Developer',
  url: 'https://www.good.is/',
  description: 'I worked on the product team for 3 years, building a social network and solving performance problems at scale.',
  thumbnail: goodLogoThumb,
  video: null,
  lightBg: true,
  media: [
    { type: 'image', src: goodLogo },
  ],
}

export const mso = {
  name: 'Matthews South',
  role: 'Developer',
  url: 'http://matthewssouth.com/',
  description: 'I built a python service and js client on top of capital markets share repurchase models.',
  thumbnail: msoLogoThumb,
  video: null,
  lightBg: true,
  media: [
    { type: 'image', src: msoLogo },
  ],
}

export const dbvmapper = {
  name: 'DBV Mapper',
  role: 'Developer',
  url: null,
  description: 'A building violation notification service that plots NYC building violations on a searchable map.',
  thumbnail: dbvmapperHomeThumb,
  video: null,
  media: [
    { type: 'image', src: dbvmapperHome },
  ],
}

export const spacebook = {
  name: 'Spacebook',
  role: 'Creator & Programmer',
  url: null,
  description: 'An iOS app with 6000+ high-resolution photos of space from NASA.',
  thumbnail: spacebookIcon,
  video: null,
  media: [
    { type: 'image', src: spacebookIcon },
    { type: 'image', src: spacebookDetail, thumb: spacebookDetailThumb },
    { type: 'image', src: spacebookFullscreen, thumb: spacebookFullscreenThumb },
    { type: 'image', src: spacebookGrid, thumb: spacebookGridThumb },
    { type: 'image', src: spacebookSearch, thumb: spacebookSearchThumb },
    { type: 'image', src: spacebookShuttle, thumb: spacebookShuttleThumb },
    { type: 'image', src: spacebookIPhone, thumb: spacebookIPhoneThumb },
  ],
}
